/**
 * ROF product gallery, variant controller and product-card hover gallery.
 */
(function () {
  'use strict';

  function normaliseImageKey(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      return decodeURIComponent(parsed.pathname)
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*)\.(?=[^.]+$)/i, '.')
        .toLowerCase();
    } catch (error) {
      return String(url).split('?')[0].toLowerCase();
    }
  }

  function setActiveThumbnail(imageUrl) {
    var targetKey = normaliseImageKey(imageUrl);
    document.querySelectorAll('.oft-thumb').forEach(function (thumb) {
      var active = targetKey && normaliseImageKey(thumb.getAttribute('data-large')) === targetKey;
      thumb.classList.toggle('active', Boolean(active));
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function switchImageByUrl(imageUrl, altText) {
    var main = document.getElementById('OftMainImage');
    if (!main || !imageUrl) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = imageUrl;
    if (altText) main.alt = altText;
    setActiveThumbnail(imageUrl);
  }

  function switchImage(thumb) {
    var imageUrl = thumb.getAttribute('data-large');
    if (!imageUrl) return;
    switchImageByUrl(imageUrl, thumb.getAttribute('aria-label') || 'Product image');
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest && event.target.closest('.oft-thumb');
    if (!thumb) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    switchImage(thumb);
  }, true);

  document.addEventListener('keydown', function (event) {
    var thumb = event.target.closest && event.target.closest('.oft-thumb');
    if (!thumb || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    switchImage(thumb);
  }, true);

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function getVariantImage(variant) {
    if (!variant) return '';
    if (variant.featured_image) {
      if (typeof variant.featured_image === 'string') return variant.featured_image;
      if (variant.featured_image.src) return variant.featured_image.src;
    }
    if (variant.featured_media && variant.featured_media.preview_image) {
      return variant.featured_media.preview_image.src || '';
    }
    return '';
  }

  function updatePrice(variant, currency) {
    var priceWrap = document.querySelector('.oft-price');
    if (!priceWrap) return;

    var current = priceWrap.querySelector('.current');
    if (current) current.textContent = formatMoney(variant.price, currency);

    var compare = priceWrap.querySelector('.compare');
    var compareAt = Number(variant.compare_at_price || 0);
    var price = Number(variant.price || 0);

    if (compareAt > price) {
      if (!compare) {
        compare = document.createElement('span');
        compare.className = 'compare';
        priceWrap.appendChild(compare);
      }
      compare.textContent = formatMoney(compareAt, currency);
    } else if (compare) {
      compare.remove();
    }
  }

  function updateBuyButton(variant) {
    var form = document.querySelector('.oft-product-form');
    if (!form) return;
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;

    if (!button.getAttribute('data-available-label')) {
      button.setAttribute('data-available-label', button.textContent.trim() || 'Add to basket');
    }

    button.disabled = !variant.available;
    button.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
    button.textContent = variant.available ? button.getAttribute('data-available-label') : 'Sold out';
  }

  function updateVariantUrl(variantId) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({ variantId: variantId }, '', url.toString());
  }

  function initialiseVariantController() {
    var select = document.querySelector('.oft-product-form select[name="id"]');
    if (!select || window.location.pathname.indexOf('/products/') === -1) return;
    if (select.getAttribute('data-rof-variant-controller') === 'true') return;
    select.setAttribute('data-rof-variant-controller', 'true');

    var productUrl = window.location.pathname.replace(/\/$/, '') + '.js';
    fetch(productUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product variants');
        return response.json();
      })
      .then(function (product) {
        var variantsById = {};
        (product.variants || []).forEach(function (variant) {
          variantsById[String(variant.id)] = variant;
        });

        var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || product.currency || 'GBP';

        function applySelectedVariant() {
          var variant = variantsById[String(select.value)];
          if (!variant) return;
          var imageUrl = getVariantImage(variant);
          if (imageUrl) switchImageByUrl(imageUrl, product.title + ' – ' + variant.title);
          updatePrice(variant, currency);
          updateBuyButton(variant);
          updateVariantUrl(variant.id);
        }

        select.addEventListener('change', applySelectedVariant);
        applySelectedVariant();
      })
      .catch(function () {
        select.removeAttribute('data-rof-variant-controller');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseVariantController);
  } else {
    initialiseVariantController();
  }

  document.addEventListener('shopify:section:load', initialiseVariantController);
})();

/**
 * Product-card hover gallery v4.
 * Uses Liquid-embedded image URLs and falls back to Shopify product JSON.
 */
(function () {
  'use strict';

  if (window.rofCardGalleryV4Loaded) return;
  window.rofCardGalleryV4Loaded = true;

  var FIRST_DELAY = 450;
  var CHANGE_DELAY = 900;
  var states = new WeakMap();
  var endpointCache = Object.create(null);

  function normalise(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.href);
      return decodeURIComponent(parsed.pathname)
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*)\.(?=[^.]+$)/i, '.')
        .toLowerCase();
    } catch (error) {
      return String(url).split('?')[0].toLowerCase();
    }
  }

  function addUnique(list, seen, src) {
    var key = normalise(src);
    if (!src || !key || seen[key]) return;
    seen[key] = true;
    list.push(src);
  }

  function findEmbeddedData(card) {
    var productId = card.getAttribute('data-product-id');
    var node = card.nextElementSibling;

    while (node && !(node.matches && node.matches('article.rof-card'))) {
      if (node.classList && node.classList.contains('rof-card__hover-data')) {
        if (!productId || node.getAttribute('data-product-id') === productId) return node;
      }
      node = node.nextElementSibling;
    }

    if (productId) {
      var boxes = document.querySelectorAll('.rof-card__hover-data[data-product-id]');
      for (var i = 0; i < boxes.length; i += 1) {
        if (boxes[i].getAttribute('data-product-id') === productId) return boxes[i];
      }
    }

    return null;
  }

  function productEndpoint(card) {
    var link = card.querySelector('a.rof-card__img-link[href], a.rof-card__title[href], a[href*="/products/"]');
    if (!link) return '';

    try {
      var parsed = new URL(link.href, window.location.href);
      parsed.search = '';
      parsed.hash = '';
      parsed.pathname = parsed.pathname.replace(/\/$/, '') + '.js';
      return parsed.pathname;
    } catch (error) {
      return '';
    }
  }

  function sourceFromItem(item) {
    if (!item) return '';
    if (typeof item === 'string') return item;
    return item.src || item.url || (item.preview_image && (item.preview_image.src || item.preview_image.url)) || '';
  }

  function fetchFallbackImages(card, originalSrc) {
    var endpoint = productEndpoint(card);
    if (!endpoint) return Promise.resolve(originalSrc ? [originalSrc] : []);

    if (!endpointCache[endpoint]) {
      endpointCache[endpoint] = fetch(endpoint, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load product gallery');
          return response.json();
        })
        .then(function (product) {
          var source = Array.isArray(product.images) ? product.images : (Array.isArray(product.media) ? product.media : []);
          var images = [];
          var seen = Object.create(null);
          addUnique(images, seen, originalSrc);
          source.forEach(function (item) {
            addUnique(images, seen, sourceFromItem(item));
          });
          return images;
        })
        .catch(function () {
          return originalSrc ? [originalSrc] : [];
        });
    }

    return endpointCache[endpoint];
  }

  function collectEmbeddedImages(card, originalSrc) {
    var images = [];
    var seen = Object.create(null);
    var box = findEmbeddedData(card);

    addUnique(images, seen, originalSrc);

    if (box) {
      box.querySelectorAll('[data-hover-src]').forEach(function (item) {
        addUnique(images, seen, item.getAttribute('data-hover-src'));
      });
    }

    return images;
  }

  function preload(images) {
    images.slice(1).forEach(function (src) {
      var image = new Image();
      image.decoding = 'async';
      image.src = src;
    });
  }

  function createState(card) {
    var image = card.querySelector('img.rof-card__img');
    if (!image) return null;

    var originalSrc = image.getAttribute('src') || image.currentSrc || '';
    var embedded = collectEmbeddedImages(card, originalSrc);
    var state = {
      image: image,
      originalSrc: originalSrc,
      originalSrcset: image.getAttribute('srcset'),
      originalSizes: image.getAttribute('sizes'),
      images: embedded.length > 1 ? embedded : null,
      loading: null,
      index: 0,
      timer: null,
      active: false,
      token: 0
    };

    card.setAttribute('data-rof-hover-version', '4');
    card.setAttribute('data-rof-hover-count', String(embedded.length));
    image.style.transition = 'opacity .18s ease';
    states.set(card, state);
    return state;
  }

  function stateFor(card) {
    return states.get(card) || createState(card);
  }

  function clearTimer(state) {
    if (state && state.timer) window.clearTimeout(state.timer);
    if (state) state.timer = null;
  }

  function restore(state) {
    clearTimer(state);
    state.token += 1;
    state.index = 0;
    state.image.style.opacity = '1';

    if (state.originalSrc) state.image.setAttribute('src', state.originalSrc);
    if (state.originalSrcset !== null) state.image.setAttribute('srcset', state.originalSrcset);
    else state.image.removeAttribute('srcset');
    if (state.originalSizes !== null) state.image.setAttribute('sizes', state.originalSizes);
    else state.image.removeAttribute('sizes');
  }

  function scheduleNext(card, state, delay) {
    clearTimer(state);
    if (!state.active || !state.images || state.images.length < 2) return;
    state.timer = window.setTimeout(function () {
      showNext(card, state);
    }, delay);
  }

  function showNext(card, state) {
    if (!state.active || !state.images || state.images.length < 2) return;

    state.index = (state.index + 1) % state.images.length;
    var nextSrc = state.images[state.index];
    var token = ++state.token;
    var loader = new Image();

    loader.onload = function () {
      if (!state.active || token !== state.token) return;
      state.image.style.opacity = '0.35';
      state.image.removeAttribute('srcset');
      state.image.removeAttribute('sizes');
      state.image.setAttribute('src', nextSrc);
      window.requestAnimationFrame(function () {
        state.image.style.opacity = '1';
      });
      scheduleNext(card, state, CHANGE_DELAY);
    };

    loader.onerror = function () {
      if (token !== state.token) return;
      scheduleNext(card, state, 80);
    };

    loader.src = nextSrc;
    if (loader.complete && loader.naturalWidth > 0) loader.onload();
  }

  function ensureImages(card, state) {
    if (state.images && state.images.length > 1) return Promise.resolve(state.images);
    if (state.loading) return state.loading;

    state.loading = fetchFallbackImages(card, state.originalSrc).then(function (images) {
      state.images = images;
      card.setAttribute('data-rof-hover-count', String(images.length));
      preload(images);
      return images;
    });

    return state.loading;
  }

  function start(card) {
    var state = stateFor(card);
    if (!state) return;

    state.active = true;
    clearTimer(state);

    ensureImages(card, state).then(function (images) {
      if (!state.active || !images || images.length < 2) return;
      preload(images);
      scheduleNext(card, state, FIRST_DELAY);
    });
  }

  function stop(card, shouldRestore) {
    var state = stateFor(card);
    if (!state) return;
    state.active = false;
    clearTimer(state);
    state.token += 1;
    if (shouldRestore !== false) restore(state);
  }

  document.addEventListener('mouseover', function (event) {
    var card = event.target.closest && event.target.closest('article.rof-card');
    if (!card) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    start(card);
  }, true);

  document.addEventListener('mouseout', function (event) {
    var card = event.target.closest && event.target.closest('article.rof-card');
    if (!card) return;
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    stop(card, true);
  }, true);

  document.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('article.rof-card');
    if (card) stop(card, false);
  }, true);
})();
